namespace RedBullMOBILE360.Web.API {
    export namespace TygoService {
        export const baseUrl = '~/api/Tygo';

        export declare function CheckoutActivation(request: any, onSuccess?: (response: Microsoft.AspNetCore.Mvc.IActionResult) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function InitiateAbsherAsync(request: any, onSuccess?: (response: Microsoft.AspNetCore.Mvc.IActionResult) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CheckAbsherAsync(request: Web.Services.Absher.DTOs.AbsherStatusRequest, onSuccess?: (response: Microsoft.AspNetCore.Mvc.IActionResult) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            CheckoutActivation = "~/api/Tygo/CheckoutActivation",
            InitiateAbsherAsync = "~/api/Tygo/InitiateAbsherAsync",
            CheckAbsherAsync = "~/api/Tygo/CheckAbsherAsync"
        }

        [
            'CheckoutActivation', 
            'InitiateAbsherAsync', 
            'CheckAbsherAsync'
        ].forEach(x => {
            (<any>TygoService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
